<template>
   <!-- 小程序预约单取消预约弹窗 -->
  <lk-modal v-model="cancelModal" title='取消预约'>
    <div class="modalContainer">
      取消原因：
      <lk-select v-model='selectedReason' class="item" clearable style="width:40%">
        <lk-option v-for="(item, index) in cancelReasonList" :key="index" :value="item.id">{{item.name}}</lk-option>
      </lk-select>
    </div>
    <div slot="footer" class="footerBtns">
      <lk-button @click="$emit('change', false)">取消</lk-button>
      <lk-button type='primary' @click='cancelSubmit' >确认取消</lk-button>
    </div>
  </lk-modal>
</template>
<script>
import utils from '@/libs/utils';
import sale from '@/services/sale';

export default {
  name: 'CancelOrderModal',
  props: {
    cancelOrderParams: {
      type: Object,
    },
    cancelModal: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    event: 'change',
    prop: 'cancelModal',
  },
  watch: {},
  data() {
    return {
      selectedReason: null,
      cancelReasonList: [
        {
          id: 1,
          name: '患者不想买了'
        },
        {
          id: 2,
          name: '患者填写信息有误'
        },
        {
          id: 3,
          name: '患者拍错了'
        },
        {
          id: 4,
          name: '缺货'
        },
        {
          id: 5,
          name: '其它'
        },
      ]
    };
  },
  methods: {
    cancelSubmit() { // 取消预约接口调用
      if (!this.selectedReason) {
        this.$Message.error('请先选择取消原因');
        return
      }
      const params = this.cancelOrderParams; // 取消预约入参
      params.cancelReason = this.selectedReason;
      sale.prescriptionCancel(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('取消预约成功');
          this.$emit('change', false);
          this.$emit('getData');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });

    },
  },
  mounted() { },
};
</script>
<style lang="less" scoped>
  .modalContainer{
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
